export const onboardingCurrentStepSelector = (state) =>
  state.auth.onboarding.currentStep;

export const onboardingMainFormFieldsSelector = (state) =>
  state.auth.onboarding.mainFormFields;

export const onboardingOpeningRequestIdSelector = (state) =>
  state.auth.onboarding.openingRequestId;

export const onboardingDocumentsSelector = (state) =>
  state.auth.onboarding.documents?.data;
export const onboardingErrorSelector = (state) => state.auth.onboarding.error;

export const onboardingLegalStatusSelector = (state) =>
  state.auth.onboarding.legalStatus;

export const onboardingHolderCodeSelector = (state) =>
  state.auth.onboarding.holderCode;

export const onboardingShouldShowQuestionnaireSelector = (state) =>
  state.auth.onboarding.shouldShowQuestionnaire;

export const onboardingIbanCodeSelector = (state) =>
  state.auth.onboarding.ibanCode;

export const onboardingSecondaryIbanCodeSelector = (state) =>
  state.auth.onboarding.ibanCode2;

export const onboardingBankAccountNumberSelector = (state) =>
  state.auth.onboarding.bankAccountNumber;

export const onboardingContractFileSelector = (state) =>
  state.auth.onboarding.contract.file;

export const onboardingContractDisclaimerSelector = (state) =>
  state.auth.onboarding.contract.disclaimer;

export const onboardingCreateAccountDisclaimerSelector = (state) =>
  state.auth.onboarding.createAccountDisclaimer;

export const isOnboardingContractFileLoading = (state) =>
  state.auth.onboarding.contract.isLoading;

export const onboardingDocumentsFeedback = (state) =>
  state.auth.onboarding.documents?.feedback;

export const onboardingMandatoryAndIdentificationSelector = (state) =>
  state.auth.onboarding.documents?.mandatoryAndIdentification;

export const onboardingMainNameSelector = (state) =>
  state.auth.onboarding.mainFormFields.find(
    (field) => field.name === 'name' || field.name === 'denomination',
  )?.value;

export const userInitialOtpDelivMetdsSelector = (state) =>
  state.auth.onboarding.userInitialOtpDelivMetds;

export const isJoiningProcessCompleted = (state) =>
  state.auth.onboarding.isJoinProcessCompleted;

export const legalStatusListSelector = (state) =>
  state.auth.onboarding.legalStatusList;

export const legalStatusSelector = (state) => state.auth.onboarding.legalStatus;
